export const QRCodeBlackList = ["undefined", undefined];
